import { z } from 'zod';

export const pspStatusValues = ['success', 'failure', 'deactivated', 'pending'] as const;

export const pspStatusMessageValidator = z.looseObject({
  eduzzId: z.coerce.number().int().positive(),
  document: z.string().min(1),
  pspId: z.number().int().positive(),
  status: z.enum(pspStatusValues),
  reason: z.string().nullable(),
  code: z.string().max(128).nullable().optional()
});

export type PspStatusMessage = z.infer<typeof pspStatusMessageValidator>;
